"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));
var _theme = require("../../theme");
var _Text = _interopRequireDefault(require("../Text"));
var _styles = require("@mui/material/styles");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * @param classes
 * @param title
 * @param paragraph
 * @param onClose
 * @param id
 * @param testid
 * @returns {*}
 * @constructor
 */
var InfoCard = function InfoCard(_ref) {
  var classes = _ref.classes,
    title = _ref.title,
    paragraph = _ref.paragraph,
    onClose = _ref.onClose,
    id = _ref.id,
    testid = _ref.testid,
    stillCallback = _ref.stillCallback;
  var theme = (0, _styles.useTheme)();
  var styles = {
    container: {
      backgroundColor: _theme.colors.surface,
      display: 'block',
      margin: '20px auto',
      padding: 10,
      position: 'relative',
      border: "2px solid ".concat(theme.palette.primary.main),
      borderRadius: 7,
      maxWidth: '100%'
    },
    flexBlock: {
      display: 'flex',
      justifyContent: 'flex-end'
    },
    btnStyle: {
      width: 'fit-content'
    },
    closeIcon: {
      color: _theme.colors.mediumGrey,
      fontSize: 16,
      "float": 'right',
      '&:hover': {
        cursor: 'pointer',
        color: _theme.colors.darkGrey
      }
    }
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: _objectSpread(_objectSpread({}, styles.container), styles.cardStyle),
    id: id || null
  }, /*#__PURE__*/_react["default"].createElement(_Close["default"], {
    sx: styles.closeIcon,
    onClick: onClose
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    testid: testid,
    align: "left",
    medium: true,
    bold: true,
    display: "block",
    margin: "10px"
  }, title), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    align: "left",
    small: true,
    display: "block",
    margin: "10px"
  }, paragraph));
};
var _default = exports["default"] = InfoCard;